import React from "react";

import strings from "../../resources/strings";

class ChromeOnIOSErrorMessage extends React.Component {
    render() {
        return (
            <div className="w3-container w3-center">
                <div id="emailSmsLabel" className="w3-text-center w3-center w3-margin-top">
                    {strings.getString("chromeBrowserMessage")}<br/>
                </div>
            </div>
        );
    }
}

export default ChromeOnIOSErrorMessage;
